import { render, staticRenderFns } from "./form-group.vue?vue&type=template&id=637a39aa&"
import script from "./form-group.vue?vue&type=script&lang=js&"
export * from "./form-group.vue?vue&type=script&lang=js&"
import style0 from "./form-group.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports